import { useQuery } from "@tanstack/react-query";
import { useAuth } from "react-oidc-context";

import { listRecentDeployments } from "@/api/deployments";
import { POLL_INTERVAL_MS, hasInflight } from "@/lib/deployments";

/**
 * Global task feed for the shell's bottom panel + the Datacenter dashboard.
 *
 * Mirrors the per-tenant polling contract used by TenantDetail /
 * TenantDeployments: poll every {@link POLL_INTERVAL_MS} while at least one run
 * is in flight, then stop; suspended in background tabs so an open-overnight
 * tab doesn't burn invocations. The query key is shared so both consumers read
 * one cache entry.
 */
export function useRecentDeployments(limit = 50) {
  const auth = useAuth();
  const token = auth.user?.id_token ?? "";

  return useQuery({
    queryKey: ["deployments", "recent"],
    queryFn: () => listRecentDeployments(token, { limit }),
    enabled: !!token,
    refetchInterval: (q) =>
      hasInflight(q.state.data?.items ?? []) ? POLL_INTERVAL_MS : false,
    refetchIntervalInBackground: false,
  });
}
